import { AccountManagerInvitePage } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/account-manager-invite/$inviteCode'].update({
        staticData: { title: { page: 'Title.AccountManagerInvite' } },
        component: authGuard(AccountManagerInvitePage)
    });
};
